import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { NavigationEnd, Router, RouterModule } from "@angular/router";
import { MaterialModule } from "../../../modules/material.module";
import { MatDrawerContent } from "@angular/material/sidenav";
import { LayoutService } from "../../services/layout.service";
import { Subject, takeUntil } from "rxjs";

@Component({
    selector: "app-main-layout",
    standalone: true,
    imports: [RouterModule, MaterialModule],
    templateUrl: "./main-layout.component.html",
    styleUrl: "./main-layout.component.scss",
})
export class MainLayoutComponent implements OnInit, OnDestroy {
    @ViewChild(MatDrawerContent) drawerContent!: MatDrawerContent;

    private destroy$ = new Subject<void>();

    constructor(
        private router: Router,
        private layoutService: LayoutService,
    ) {}

    ngOnInit(): void {
        this.initNavigationSubscription();
        this.initManualScrollingSubscription();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private initNavigationSubscription(): void {
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            this.drawerContent.scrollTo({ top: 0, behavior: "smooth" });
        });
    }

    private initManualScrollingSubscription(): void {
        this.layoutService.scrollToTop$.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.drawerContent.scrollTo({ top: 0, behavior: "smooth" });
        });
    }
}
